import React from "react"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
  BlockQuote,
  Heading,
  AutoLink,
  Link,
  List,
  Table,
  TableToolbar,
  Alignment,
} from "ckeditor5"
import "ckeditor5/ckeditor5.css"

function Editor({ value, initialData, data, onChange, disabled, isReadOnly }) {
  return (
    <CKEditor
      editor={ClassicEditor}
      disabled={disabled}
      config={{
        toolbar: {
          items: [
            "undo",
            "redo",
            "|",
            "heading",
            "|",
            "bold",
            "blockQuote",
            "italic",
            "link",
            "|",
            "bulletedList",
            "numberedList",
            "alignment",
          ],
        },
        isReadOnly: isReadOnly,
        plugins: [
          Bold,
          Essentials,
          Italic,
          Mention,
          Paragraph,
          Undo,
          BlockQuote,
          Heading,
          Link,
          AutoLink,
          List,
          Table,
          TableToolbar,
          Alignment,
        ],
        initialData: data || "<p>Description</p>",
      }}
      onChange={onChange}
      data={data || ""}
    />
  )
}

export default Editor
